<!--<div *ngIf="status && (status.status === 'expiring' || status.status === 'expired')" class="license-banner" [ngClass]="status.status">-->
<!--    <strong *ngIf="status.status === 'expiring'">-->
<!--        ⚠️ Votre licence expire dans {{ status.days_remaining }} jours (jusqu’au {{ status.end_date }}) !-->
<!--    </strong>-->
<!--    <strong *ngIf="status.status === 'expired'">-->
<!--        ❌ Votre licence a expiré le {{ status.end_date }}.-->
<!--    </strong>-->
<!--</div>-->

<div
        *ngIf="!closed && status && (status.status === 'expiring' || status.status === 'expired' || status.status === 'missing')"
        class="license-banner"
        [ngClass]="status.status"
>
    <button class="close-btn" (click)="closeBanner()">✖</button>

    <strong *ngIf="status.status === 'expiring'">
        ⚠️ Votre licence expire dans {{ status.days_remaining }} jours (jusqu’au {{ status.end_date }}) !
    </strong>
    <strong *ngIf="status.status === 'expired'">
        ❌ Votre licence a expiré le {{ status.end_date }}.
    </strong>
	<strong *ngIf="status.status === 'missing'">
        😢 {{ status.message }}
    </strong>
</div>
